const translations = {
    placeholder: 'Select your reporting period',
    required: 'This field is required'
};

export default translations;
